module.exports = __webpack_public_path__ + "static/media/tienda.a7c7ac10.png";